import { render, staticRenderFns } from "./SupiTable.vue?vue&type=template&id=12d01ec3&scoped=true&"
import script from "./SupiTable.vue?vue&type=script&lang=js&"
export * from "./SupiTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d01ec3",
  null
  
)

export default component.exports